import React, { useEffect, useState } from "react";
import "./ProfilePage.scss";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../../../common/Validations";
import toast from "react-hot-toast";
import ItemService from "../../../../services/commonService";
import { addUser } from "../../../../redux/feature/userSlice";
import { useDispatch } from "react-redux";
import Constants from "../../../../common/Constants";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.user); // User Details from Store
  const appConfig = useSelector((state) => state?.common?.data); // User Details from Store

  const [editMode, setEditMode] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [appConfigData, setAppConfigData] = useState(false);

  const [profile, setProfile] = useState({
    userId: "ADMIN001",
    firstName: "Santhosh Kumar",
    lastName: "Santhosh Kumar",
    email: "santhosh@example.com",
    contactNumber: "9876543210",
    category: "Admin",
    updatedDate: "2026-06-23T12:04:44.864Z",
  });

  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    setProfile(userData.data);
    setAppConfigData(appConfig);
  }, [userData, appConfig]);

  const handleProfileChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPassword({ ...password, [e.target.name]: e.target.value });
  };

  //   const updateProfile = () => {
  //     console.log("Updated Profile:", profile);
  //     setEditMode(false);
  //   };

  const updateProfile = async () => {
    if (
      !profile.firstName?.trim() ||
      !profile.lastName?.trim() ||
      !profile.contactNumber?.trim()
    ) {
      toast.error("First Name, Last Name and Contact Number are mandatory", {
        position: "top-right",
      });
      return;
    }

    const data = {
      firstName: profile.firstName,
      lastName: profile.lastName,
      contactNumber: profile.contactNumber,
      email: profile.email,
      _id: profile._id,
      action: "Profile",
    };

    const toastId = toast.loading("Updating Profile...", {
      position: "top-right",
    });

    try {
      const item = await ItemService.userUpdate(data);

      if (item?.status === 200) {
        toast.success(item?.message || "User Updated successfully", {
          duration: 2000,
          position: "top-right",
        });

        dispatch(addUser(data));

        setProfile((prev) => ({
          ...prev,
          ...data,
          updatedDate: new Date().toISOString(),
        }));

        setEditMode(false);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Profile Update Error:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong",
        {
          duration: 4000,
          position: "top-right",
        },
      );
    } finally {
      toast.dismiss(toastId);
    }
  };

  const updatePassword = async () => {
    if (
      !password.oldPassword?.trim() ||
      !password.newPassword?.trim() ||
      !password.confirmPassword?.trim()
    ) {
      toast.error("Please fill all password fields", {
        position: "top-right",
        duration: 4000,
      });
      return;
    }

    if (password.newPassword !== password.confirmPassword) {
      toast.error("New Password and Confirm Password do not match", {
        position: "top-right",
        duration: 4000,
      });
      return;
    }

    if (password.newPassword.length < 6) {
      toast.error("Password must be at least 6 characters", {
        position: "top-right",
        duration: 4000,
      });
      return;
    }

    const toastId = toast.loading("Updating Password...", {
      position: "top-right",
    });

    try {
      // API Call Here
      const data = {
        password: password.oldPassword,
        confirmPassword: password.newPassword,
        _id: profile._id,
        action: "Change_Password",
      };

      const item = await ItemService.userUpdate(data);

      if (item?.status === 200) {
        toast.success("Password updated successfully", {
          position: "top-right",
          duration: 2000,
        });

        setPassword({
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });

        setShowPassword(false);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Password Update Error:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to update password",
        {
          position: "top-right",
          duration: 4000,
        },
      );
    } finally {
      toast.dismiss(toastId);
    }
  };

  return (
    <main className="generatejobcard main" id="main">
      <div className="profile-wrapper">
        <div className="profile-card profile-card-wrapper">
          {appConfigData?.profileUpdate === false && (
            <div className="demo-banner">
              <i className="bi bi-info-circle-fill"></i>
              <div>
                <h6>Demo Version</h6>
                <p>
                  Profile editing and password updates are disabled in the demo
                  version.
                </p>
              </div>
            </div>
          )}
          <div className="profile-top">
            <div className="profile-bg"></div>

            <div className="profile-avatar">
              <i className="bi bi-person-fill"></i>
            </div>

            <h3>
              {profile.firstName} {profile.lastName}
            </h3>
            <p>{profile.category}</p>
          </div>

          {userData?.data?.category === Constants.MASTER.USERS.ADMIN && (
            <div className="profile-actions">
              <button
                className={editMode ? "btn-cancel" : "btn-edit"}
                disabled={appConfigData?.profileUpdate === false}
                onClick={() => setEditMode(!editMode)}
              >
                <i
                  className={`bi ${editMode ? "bi-x-circle" : "bi-pencil-square"}`}
                ></i>
                {editMode ? "Cancel" : "Edit Profile"}
              </button>

              {editMode && (
                <button
                  className="btn-save"
                  onClick={updateProfile}
                  disabled={appConfigData?.profileUpdate === false}
                >
                  <i className="bi bi-check-circle"></i>
                  Update
                </button>
              )}
            </div>
          )}

          <div className="profile-form">
            <div className="form-group">
              <label>User ID</label>
              <div className="input-icon">
                <i className="bi bi-person-badge"></i>
                <input value={profile.userId} disabled={true} />
              </div>
            </div>

            <div className="form-group">
              <label>Category</label>
              <div className="input-icon">
                <i className="bi bi-building"></i>
                <input
                  name="category"
                  value={profile.category}
                  disabled={true}
                />
              </div>
            </div>

            <div className="form-group">
              <label>First Name</label>
              <div className="input-icon">
                <i className="bi bi-person"></i>
                <input
                  name="firstName"
                  value={profile.firstName}
                  disabled={!editMode || appConfigData?.profileUpdate === false}
                  onChange={handleProfileChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Last Name</label>
              <div className="input-icon">
                <i className="bi bi-person"></i>
                <input
                  name="lastName"
                  value={profile.lastName}
                  disabled={!editMode || appConfigData?.profileUpdate === false}
                  onChange={handleProfileChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Email</label>
              <div className="input-icon">
                <i className="bi bi-envelope"></i>
                <input
                  name="email"
                  value={profile.email}
                  disabled={!editMode || appConfigData?.profileUpdate === false}
                  onChange={handleProfileChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Contact Number</label>
              <div className="input-icon">
                <i className="bi bi-phone"></i>
                <input
                  name="contactNumber"
                  value={profile.contactNumber}
                  disabled={!editMode || appConfigData?.profileUpdate === false}
                  onChange={handleProfileChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Last Updated</label>
              <div className="input-icon">
                <i className="bi bi-clock-history"></i>
                <input
                  name="updatedDate"
                  value={formatDateTime(profile.updatedDate)}
                  disabled={true}
                />
              </div>
            </div>
          </div>

          {userData?.data?.category === Constants.MASTER.USERS.ADMIN && (
            <div className="password-toggle">
              <button
                onClick={() => setShowPassword(!showPassword)}
                disabled={appConfigData?.profileUpdate === false}
              >
                <i className="bi bi-shield-lock"></i>
                Change Password
                <i
                  className={`bi ${showPassword ? "bi-chevron-up" : "bi-chevron-down"}`}
                ></i>
              </button>
            </div>
          )}

          {showPassword && (
            <div className="password-box">
              <div className="form-group">
                <label>Old Password</label>
                <input
                  type="password"
                  name="oldPassword"
                  value={password.oldPassword}
                  onChange={handlePasswordChange}
                  disabled={!editMode || appConfigData?.profileUpdate === false}
                />
              </div>

              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  name="newPassword"
                  value={password.newPassword}
                  onChange={handlePasswordChange}
                  disabled={!editMode || appConfigData?.profileUpdate === false}
                />

                {password.newPassword && (
                  <div className="password-strength">
                    <div
                      className={`strength-bar ${
                        password.newPassword.length < 6
                          ? "weak"
                          : password.newPassword.length < 10
                            ? "medium"
                            : "strong"
                      }`}
                    ></div>

                    <span
                      className={`strength-text ${
                        password.newPassword.length < 6
                          ? "weak"
                          : password.newPassword.length < 10
                            ? "medium"
                            : "strong"
                      }`}
                    >
                      {password.newPassword.length < 6
                        ? "Weak Password"
                        : password.newPassword.length < 10
                          ? "Medium Password"
                          : "Strong Password"}
                    </span>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={password.confirmPassword}
                  onChange={handlePasswordChange}
                  disabled={!editMode || appConfigData?.profileUpdate === false}
                />

                {password.confirmPassword && (
                  <div
                    className={`password-match ${
                      password.newPassword === password.confirmPassword
                        ? "match"
                        : "not-match"
                    }`}
                  >
                    <i
                      className={`bi ${
                        password.newPassword === password.confirmPassword
                          ? "bi-check-circle-fill"
                          : "bi-x-circle-fill"
                      }`}
                    ></i>

                    {password.newPassword === password.confirmPassword
                      ? "Passwords Match"
                      : "Passwords Do Not Match"}
                  </div>
                )}
              </div>
              {profile.changed_password_at && (
                <div className="password-last-updated">
                  <i className="bi bi-clock-history"></i>
                  <span>
                    Password Updated:
                    <strong>
                      {formatDateTime(profile.changed_password_at)}
                    </strong>
                  </span>
                </div>
              )}

              <button
                className="btn-password"
                onClick={updatePassword}
                disabled={
                  !password.oldPassword ||
                  !password.newPassword ||
                  !password.confirmPassword ||
                  password.newPassword !== password.confirmPassword
                }
              >
                <i className="bi bi-key"></i>
                Update Password
              </button>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default ProfilePage;
